import { get } from 'lodash'

import type {
	EnergyFormValues,
	RawMaterialPackagingFormValues,
	TransportFormValues,
} from '../Calculator'
import type { FieldConfig } from './config'
import type { Data } from './transform'

function createOptions({
	optionsdata,
	formdata,
	path,
}: {
	optionsdata: Data
	formdata: RawMaterialPackagingFormValues &
		EnergyFormValues &
		TransportFormValues
	path?: FieldConfig['options']
}): readonly string[] {
	if (path?.length === 0) {
		return Object.keys(optionsdata).filter(
			key => key !== 'Energy' && key !== 'Transport'
		)
	}

	const transformedpath = path?.map(key =>
		formdata ? formdata[key as FieldConfig['fieldName']] : ''
	) as readonly string[]

	return Object.keys(get(optionsdata, transformedpath, []))
}

export { createOptions }
